module.exports = __webpack_public_path__ + "img/BonusRangedDamage.ba668a87.png";